import { Vue, BitrixVue } from 'ui.vue';
import './style.css';
BX.ready(function () {
    if (BX.isNodeInDom(BX('sber-right-panel'))) {
        BitrixVue.createApp({
            el: '#sber-right-panel',
            store: userStore,
            data() {
                return {
                    // sberoffer: {}
                };
            },
            computed: {
                localize(state) {
                    return BX.Vue.getFilteredPhrases("");
                },
                basket_id(state) {
                    return this.$store.getters['basket/getId'];
                },
                contragents(state) {
                    return this.$store.getters.getContragents;
                },
                contragent(state) {
                    return this.$store.getters['basket/getContragent'];
                },
            },
            mounted() { },
            methods: {},
            filters: {},
        });
    }
    BX.addCustomEvent('OnAfterContragentChange', BX.delegate(function () {
        BX.ajax({
            url: '/local/tools/sber/auth.php?task=update-sber-offer&contragent=' + userStore.getters['basket/getContragentId'],
            data: "",
            method: 'POST',
            dataType: 'json',
            timeout: 30,
            async: true,
            processData: true,
            scriptsRunFirst: false,
            emulateOnload: true,
            start: true,
            cache: false,
            onsuccess: function (data) {
                if (data != undefined && data.SBEROFFER != undefined) {
                    var mycontragent = userStore.getters['basket/getContragent'];
                    if (typeof mycontragent != 'undefined' && mycontragent.ID != undefined) {
                        mycontragent.SBEROFFER = {
                            TEXT: data.SBEROFFER.TEXT,
                            PRICE: data.SBEROFFER.PRICE,
                            MINPRICE: data.SBEROFFER.MINPRICE,
                            TOKEN: data.SBEROFFER.TOKEN,
                        	BUYONCREDITMMB: data.SBEROFFER.BUYONCREDITMMB,
                        };
                        userStore.commit("updateContragent", mycontragent);
                    }
                } else {
                    console.error("ERROR: sber get offer empty responce");
                }
            },
            onfailure: function (error) {
                console.error("ERROR: sber get authlink empty responce", error);
            }
        });
    }, this));
});
$(document).on('click', '.sber-button a#sber-button-login', function (event) {
    event.stopPropagation();
    event.preventDefault();
    BX.ajax({
        url: '/local/tools/sber/auth.php?task=get_auth_link',
        data: "",
        method: 'POST',
        dataType: 'html',
        timeout: 30,
        async: true,
        processData: true,
        scriptsRunFirst: false,
        emulateOnload: true,
        start: true,
        cache: false,
        onsuccess: function (data) {
            if (data != undefined) {
                window.location.href = data;
            } else {
                console.error("ERROR: sber get authlink empty responce");
            }
        },
        onfailure: function (error) {
            console.error("ERROR: sber get authlink empty responce", error);
        }
    });
});
$(document).on('click', '.sber-banner a', function (event) {
    event.stopPropagation();
    event.preventDefault();
    window.open('http://www.sberbank.ru/businesscredit/partner/info?id=fit&site=https://fit24.ru/catalog/', '_blank');
});
